import { render, staticRenderFns } from "./ModalTest.vue?vue&type=template&id=007c8604"
import script from "./ModalTest.vue?vue&type=script&lang=js"
export * from "./ModalTest.vue?vue&type=script&lang=js"
import style0 from "./ModalTest.vue?vue&type=style&index=0&id=007c8604&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports